export default __webpack_public_path__ + "static/media/header-home-active.eb79a806.svg";